module.exports = __webpack_public_path__ + "static/media/aventlogo.a6c1a623.png";